import {useQuery} from '@tanstack/react-query';
import {CertadocFinesByCategory} from 'src/core/data/api/Certadoc';
import CertadocService from 'src/services/certadoc-service';

export const CERTADOC_TITLE = 'Certadoc';

export const certadocKeys = {
  all: ['certadoc'] as const,
  enabled: () => [...certadocKeys.all, 'enabled'] as const,
  fines: (deviceId?: number) => [...certadocKeys.all, 'fines', deviceId] as const,
};

/**
 * Whether the logged in user may query fines. Answered by the server.
 */
export const useCertadocEnabled = () => {
  const certadocService = new CertadocService();

  // No initialData here: react-query treats it as fresh, so combined with a staleTime the request
  // would never be made and the action would stay hidden forever.
  const {data} = useQuery<unknown, unknown, {enabled: boolean}>({
    queryKey: certadocKeys.enabled(),
    queryFn: () => certadocService.enabled(),
    retry: false,
  });

  return data?.enabled === true;
};

export const useDeviceFines = (deviceId?: number) => {
  const certadocService = new CertadocService();

  return useQuery<unknown, unknown, CertadocFinesByCategory>({
    queryKey: certadocKeys.fines(deviceId),
    queryFn: () => certadocService.fines(deviceId as number),
    enabled: !!deviceId,
    retry: false,
  });
};
